import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';

const UserIntrest = ({interests}) => {
    const [moreCourseView,setMoreCourseView] = useState(false)
    const [moreUniversityView,setMoreUniversityView] = useState(false)
    const [moreSpecializationView,setMoreSpecializationView] = useState(false)


    const handleToggleMoreCourse = ()=>setMoreCourseView(!moreCourseView)
    const handleToggleMoreUniversity = ()=>setMoreUniversityView(!moreUniversityView)
    const handleToggleMoreSpecialization = ()=>setMoreSpecializationView(!moreSpecializationView)


    const multiCourseBtb = interests?.courses || [];
    const visibleCourses = moreCourseView ? multiCourseBtb : multiCourseBtb?.slice(0, 3);
    const remainingCount = multiCourseBtb?.length - visibleCourses?.length;

    const colorStyles = [
        { bg: '#F9F5FF', color: '#6740C2' },
        { bg: '#0D99FF1A', color: '#038FF5' },
        { bg: '#FDC7271A', color: '#FDC727' },
        { bg: '#FDF0F0', color: '#FDC727' },
        { bg: '#EDF4FF', color: '#0B63CE' },
    ];
    const specializationBtn =interests?.specializations || [];
    const specialization =moreSpecializationView ? specializationBtn : specializationBtn?.slice(0, 2);
    const remainingCountspecilization = specializationBtn?.length - specialization?.length;

    const colorStylesSpecilization = [
        { bg: '#14AE5C14', color: '#14AE5C' },
        { bg: '#0D99FF1A', color: '#038FF5' },
        { bg: '#FDC7271A', color: '#FDC727' },
        { bg: '#FDF0F0', color: '#FDC727' },
        { bg: '#EDF4FF', color: '#0B63CE' },
    ];




    const universityBtn = interests?.universities || [];
    const universityView = moreUniversityView ?  universityBtn : universityBtn?.slice(0, 2);
    const universityCount = universityBtn?.length - universityView?.length;

    const colorStylesuniversity = [
        { bg: '#14AE5C14', color: '#14AE5C' },
        { bg: '#0D99FF1A', color: '#038FF5' },
        { bg: '#FDC7271A', color: '#FDC727' },
        { bg: '#FDF0F0', color: '#FDC727' },
        { bg: '#EDF4FF', color: '#0B63CE' },
    ];
    return (

        <>

            <Box
                sx={{
                    background: '#fff',
                    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
                    padding: '25px',
                    borderRadius: '16px',
                    marginBottom: '25px',height: '585px',
                    overflowY: 'scroll'
                }}
            >
                <Box>
                    <Typography
                        variant='h2'
                        sx={{
                            color: '#1E1E1E',
                           fontSize: {xl: '24px !important' , lg: '17px !important'},
                            marginBottom: '35px',
                            fontWeight: '500',
                        }}
                    >
                        User Interests
                    </Typography>
                </Box>
                <Box sx={{ marginBottom: '25px' }}>
                    <Typography
                        sx={{
                            fontSize: {xl: '18px !important' , lg: '14px !important'},
                            fontWeight: '500',
                            color: '#000',
                            marginBottom: '13px',

                        }}
                    >
                        Course Viewed
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '10px',
                        }}
                    >
                        {visibleCourses.map((item, index) => {
                            const style = colorStyles[index % colorStyles.length];
                            return (
                                <Typography
                                    key={index}
                                    sx={{
                                        borderRadius: '12px',
                                        background: style.bg,
                                        color: style.color,
                                        fontSize: {xl: '16px !important' , lg: '13px !important'},
                                        minWidth: {xl: '80px !important' , lg: '50px !important'},
                                        height: '38px',
                                        padding: '8px 16px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    {item || "-"}
                                </Typography>
                            );
                        })}

                        {remainingCount > 0 && (
                            <Button onClick={handleToggleMoreCourse}>
                            <Typography
                                sx={{
                                    borderRadius: '12px',
                                    background: '#fff',
                                    border: '1px solid #ddd',
                                    color: '#787878',
                                     fontSize: {xl: '16px !important' , lg: '13px !important'},
                                        minWidth: {xl: '80px !important' , lg: '50px !important'},
                                    height: '38px',
                                    padding: '8px 16px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                +{remainingCount}
                            </Typography>
                            </Button>
                        )}
                    </Box>
                </Box>

                <Box sx={{ marginBottom: '25px' }}>
                    <Typography
                        sx={{
                              fontSize: {xl: '18px !important' , lg: '14px !important'},
                            fontWeight: '500',
                            color: '#000',
                            marginBottom: '13px',
                        }}
                    >
                        Specialization
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '10px',
                        }}
                    >
                        {specialization.map((item, index) => {
                            const style = colorStylesSpecilization[index % colorStylesSpecilization.length];
                            return (
                                <Typography
                                    key={index}
                                    sx={{
                                        borderRadius: '12px',
                                        background: style.bg,
                                        color: style.color,
                                       fontSize: {xl: '16px !important' , lg: '13px !important'},
                                        minWidth: {xl: '80px !important' , lg: '50px !important'},
                                        height: '38px',
                                        padding: '8px 16px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    {item || "-"}
                                </Typography>
                            );
                        })}

                        {remainingCountspecilization > 0 && (
                              <Button onClick={handleToggleMoreSpecialization}>
                            <Typography
                                sx={{
                                    borderRadius: '12px',
                                    background: '#fff',
                                    border: '1px solid #ddd',
                                    color: '#787878',
                                   fontSize: {xl: '16px !important' , lg: '13px !important'},
                                        minWidth: {xl: '80px !important' , lg: '50px !important'},
                                    height: '38px',
                                    padding: '8px 16px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                +{remainingCountspecilization}
                            </Typography>
                              </Button>
                        )}
                    </Box>
                </Box>


                <Box sx={{ marginBottom: '25px' }}>
                    <Typography
                        sx={{
                              fontSize: {xl: '18px !important' , lg: '14px !important'},
                            fontWeight: '500',
                            color: '#000',
                            marginBottom: '13px',
                        }}
                    >
                        University Viewed
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '10px',
                        }}
                    >
                        {universityView.map((item, index) => {
                            const style = colorStylesuniversity[index % colorStylesuniversity.length];
                            return (
                                <Typography
                                    key={index}
                                    sx={{
                                        borderRadius: '12px',
                                        background: style.bg,
                                        color: style.color,
                                       fontSize: {xl: '16px !important' , lg: '13px !important'},
                                        minWidth: {xl: '80px !important' , lg: '50px !important'},
                                        height: '38px',
                                        padding: '8px 16px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    {item || "-"}
                                </Typography>
                            );
                        })}

                        {universityCount > 0 && (
                              <Button onClick={handleToggleMoreUniversity}>
                            <Typography
                                sx={{
                                    borderRadius: '12px',
                                    background: '#fff',
                                    border: '1px solid #ddd',
                                    color: '#787878',
                                    fontSize: '16px',
                                    minWidth: '80px',
                                    height: '38px',
                                    padding: '8px 16px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                +{universityCount}
                            </Typography>
                              </Button>
                        )}
                    </Box>
                </Box>
            </Box>



        </>



    );
};

export default UserIntrest;
